import React from "react";
import { servicesInfo } from "./data";
import InfoModal from "./InfoModal";
import submit from "submit-form";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const servicesController = async ({ res, req, load, locals }) => {
  const { query = {} } = req;
  const { modal = {} } = query;
  locals.modal = {
    information: <InfoModal service={req.query.service} />,
    "activity-feed": <ActivityDrawer />,
  }[modal.type];
  res.body = <View />;
};

const View = () => {
  const openServiceModal = (key) => {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "information",
        service: key,
      },
    });
  };
  return (
    <main className="services-wrapper">
      <header>
        <h3>MSB Services</h3>
        <p className="p5">
          Unlock the full power of your app and accelerate sales
        </p>
      </header>
      <section>
        {Object.keys(servicesInfo).map((key) => {
          const data = servicesInfo[key];
          return (
            <article key={key}>
              <img
                src={data.img}
                onClick={() => openServiceModal(key)}
                alt="service image"
              />
              <footer>
                <div>
                  <p className="s1">{data.title}</p>
                  <p>${data.price} USD</p>
                </div>
                <a
                  role="button"
                  data-button-type="outline"
                  href={data.link}
                  target="_blank"
                >
                  <span>Buy Now</span>
                </a>
              </footer>
            </article>
          );
        })}
      </section>
    </main>
  );
};

export default servicesController;
